export default __webpack_public_path__ + "static/media/ExcavationSite.6f4c1c0a.jpg";